<template>
    <div>

        <div style="width:100%;overflow:hidden;">
            <div v-if="sliderData !== null">

                <div v-if="configs.shopicon !== null && configs.shopicon !== ''"
                    :class="{ 'col-md-4 col-xs-12': sliderData.length > 0 }" style="text-align:center;">
                    <div style="display:inline-block;padding-top:20px;">
                        <img class="img-responsive" style="max-height:160px;border-radius:10px;" :src="configs.shopicon" />
                    </div>
                    <div class="col-md-12 col-xs-12 agx-shop-news" v-for="item in configs.shopNews">
                        <div v-if="item.msgType === '0'">
                            <h4>{{ item.title }}</h4>
                            <div style="white-space:pre-line;">{{ item.content }}</div>
                        </div>
                    </div>
                </div>

                <div :class="{ 'col-md-8 col-xs-12': configs.shopicon !== null && configs.shopicon !== '' }">
                    <div class="agx-shop-banner" style="margin:0 auto;">
                        <slider v-if="sliderData.length > 0" :slider-data="sliderData"></slider>
                    </div>
                </div>
            </div>

            <div class="" style="background:rgba(251, 249, 249, 0.8);"
                v-if="filterInfo !== null && filterInfo.promos !== null && filterInfo.promos.length > 0">
                <div style="background:#ddd;height:12px;"></div>
                <div v-for="(pro, index) in filterInfo.promos" style="margin:2px;">

                    <div style="padding:2px;" class="col-xs-12" v-if="filterInfo.promos.length % 2 !== 0 && index === 0">

                        <div class="col-xs-12">

                            <div style="position:relative;text-align:center;height:100px;bottom:0px;">
                                <a :href="pro.link">
                                    <img class="img-responsive" style="max-height:100px;display:inline-block;margin:0 auto;"
                                        :src="pro.image" />
                                </a>
                            </div>
                        </div>

                        <div class="col-xs-12"
                            style="position:relative;display:inline-block;bottom:0px;font-weight:bold;text-align:center;">
                            <div class="glyphicon glyphicon-link" style="display:inline-block;color:red;"></div>
                            <div>
                                <a :href="pro.link"> {{ pro.message }}</a>
                            </div>
                        </div>
                        <div style="height:10px;" class="col-xs-12"></div>
                    </div>

                    <div style="padding:2px;" class="col-xs-12 col-md-6" v-else>

                        <div class="col-xs-6 col-md-6 col-sm-6">

                            <div style="position:relative;text-align:center;height:100px;bottom:0px;">
                                <a :href="pro.link">
                                    <img class="img-responsive" style="max-height:100px;display:inline-block;margin:0 auto;"
                                        :src="pro.image" />
                                </a>
                            </div>
                        </div>

                        <div class="col-xs-6 col-md-6 col-sm-6">
                            <div style="bottom:0px;font-weight:bold;text-align:center;">
                                <div class="glyphicon glyphicon-link" style="display:inline-block;color:red;"></div>
                                <div>
                                    <a :href="pro.link"> {{ pro.message }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="position:relative;z-index:20;">
            <filter-menu-form :filter-info="filterInfo" :showKeyOnly="true" :show-level-one-menu="true"></filter-menu-form>
        </div>

        <!-- <div>
            <ul class="nav nav-pills nav-justified" style="text-align: center;">
                <li role="presentation" v-for="(pInfo, index) in pagedInfos" :class="{ active: index === pagedIndex }"><a
                        @click.prevent="changePagedIndex(index)" href="#">{{ pInfo.title }}</a>
                </li>
                <li role="presentation" v-for="(pInfo, index) in pagedInfos" :class="{ active: index === pagedIndex }"><a
                        @click.prevent="changePagedIndex(index)" href="#">{{ pInfo.title }}</a>
                </li>
            </ul>
        </div> -->
        <div>
            <template v-if="pagedInfos && pagedInfos.length > 0">
                <div v-for="(pInfo, index) in pagedInfos" style="clear:both;">
                    <div class="agx-theme-bg" style="text-align: center;">
                        <span role="presentation" class="active" @click.prevent="changePagedIndex(index)">
                            <span class="btn">{{ pInfo.title }}</span>
                        </span>
                    </div>
                    <paged-infos :init-filter="pInfo"></paged-infos>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import PagedInfos from '../components/PagedInfos.vue';
import Slider from '../components/slider/Slider.vue';
import FilterMenuForm from './FilterMenuForm.vue';

export default {
    components: {
        FilterMenuForm: FilterMenuForm,
        PagedInfos: PagedInfos,
        Slider: Slider
    },
    props: {
        "configs": Object,
        "filterInfo": Object,
        "sliderData": { type: Array, default: null }
    },
    computed: {
        pagedInfos: function () {
            var arr = this.configs.pagedInfos.indexTop;
            return arr;
        }
    },
    methods: {
        changePagedIndex(index) {
            this.pagedIndex = index;
        }
    },
    data: function () {
        return {
            pagedIndex: 0
        }
    },
    mounted: function () {

    }
}
</script>